import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { required, textRangeLength, withMessage } from '@certemy/common';
import { Subject } from 'rxjs';
import _get from 'lodash-es/get';
import {
  DEFAULT_LABEL_SETTINGS,
  GlobalOrganizationsLabel,
} from 'features/global-organizations-setting-state/global-organizations-setting.constant';
import { getMergedFormErrors } from 'utils/helpers';
import _uniq from 'lodash-es/uniq';
import { SmartForm } from '@certemy/ui-components';

const requiredWithMessage = withMessage('Please fill out all fields', required);

@Component({
  selector: 'cm-first-login-form',
  templateUrl: 'first-login-form.component.html',
  styleUrls: ['first-login-form.component.scss'],
})
export class FirstLoginFormComponent implements OnInit, OnDestroy {
  @Input() fields: any[] = [];
  @Input() type = '';
  @Input() profile;
  @Input() featureFlagsData;
  @Input() locations;
  @Input() disabled: boolean = false;
  @Input() organizationLabels: GlobalOrganizationsLabel = DEFAULT_LABEL_SETTINGS;
  @Input() organizationRoles: SmartForm.FieldOption[];
  @Output() done = new EventEmitter<any>();

  form: UntypedFormGroup;
  terms_condition = false;
  showLocationsForm = false;
  validationMessages: string[];
  showErrors: boolean;
  isProfessionalForm: boolean;

  private onDestroy$ = new Subject<void>();

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.isProfessionalForm = this.type === 'professional';
    const isLocationFeatureFlagEnabled = _get(this.featureFlagsData, 'isLocationFeatureFlagEnabled', false);
    this.showLocationsForm = isLocationFeatureFlagEnabled && this.isProfessionalForm && this.locations;
    this.form = this.fb.group({
      first_name: [this.profile.first_name, [requiredWithMessage, textRangeLength('First name')]],
      last_name: [this.profile.last_name, [requiredWithMessage, textRangeLength('Last name')]],
      email: [
        {
          value: this.profile.email,
          disabled: true,
        },
      ],
      ...(this.type === 'organization'
        ? {
            organization_name: [this.profile.organization_name || '', requiredWithMessage],
          }
        : {}),
      ...(this.type === 'professional' && this.featureFlagsData.isOrganizationRolesFeatureFlagEnabled
        ? {
            organizationRoleId: [
              {
                value: this.profile.organizationRoleId || null,
                disabled: !!this.profile.organizationRoleId,
              },
              this.organizationRoles.length && !this.profile.organizationRoleId ? requiredWithMessage : [],
            ],
          }
        : {}),
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onSubmit(form: UntypedFormGroup) {
    const value = form.getRawValue();
    this.showErrors = this.form.invalid;
    this.validationMessages = [];
    if (!this.terms_condition) {
      this.showErrors = true;
      this.validationMessages = ['You must agree with the terms and conditions'];
    }
    if (this.form.valid && !this.showErrors) {
      this.done.emit({
        ...value,
        accept_terms: true,
      });
    } else {
      const validationMessages = _uniq([
        ...(getMergedFormErrors(this.form)
          .map(errors => Object.values(errors).find(el => typeof el === 'string'))
          .filter(hasValidationMessage => !!hasValidationMessage) || ['Please fill out all fields']),
        ...this.validationMessages,
      ]);
      this.validationMessages = [validationMessages[0]];
    }
  }
}
